import { Button } from "primereact/button"
import { useNavigate } from "react-router-dom"

const KBButton = ()=>{
    const navigate = useNavigate()

    const handlePage = (e)=>{
        e.preventDefault()
        navigate('/dashboard/kb')
    }
    return (
        <Button onClick={handlePage}>Knowledge Base</Button>
    )
}

export default KBButton